import React, { useState, useCallback } from 'react';
import Dropdown from '../../../../components/Dropdown';
import { INVOICE_STATUS_OPTIONS } from '../../config';
import { DropdownItem } from '../../../../components/Dropdown/config';
import BulkActionModal from '../BulkActionModal';

interface BulkStatusChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCount: number;
  onConfirm: (newStatus: string) => Promise<void>;
  isAllFiltered?: boolean; // True if "Select All (X)" was used
  totalFilteredCount?: number; // Total count when isAllFiltered is true
}

const BulkStatusChangeModal: React.FC<BulkStatusChangeModalProps> = ({
  isOpen,
  onClose,
  selectedCount,
  onConfirm,
  isAllFiltered = false,
  totalFilteredCount = 0
}) => {
  const [selectedStatus, setSelectedStatus] = useState<string>('');

  // Reset the field each time the modal opens.
  React.useEffect(() => {
    if (isOpen) {
      setSelectedStatus('');
    }
  }, [isOpen]);

  const statusDropdownItems: DropdownItem[] = INVOICE_STATUS_OPTIONS.map(status => ({
    id: status.id,
    label: status.label,
    value: status.value
  }));

  const handleStatusChange = useCallback((value: string | string[]) => {
    setSelectedStatus(Array.isArray(value) ? value[0] : value);
  }, []);

  return (
    <BulkActionModal
      isOpen={isOpen}
      onClose={onClose}
      title="Change Invoice Status"
      verb="Change the status of"
      connector="to:"
      selectedCount={selectedCount}
      isAllFiltered={isAllFiltered}
      totalFilteredCount={totalFilteredCount}
      canConfirm={!!selectedStatus}
      onConfirm={() => onConfirm(selectedStatus)}
    >
      <label className="bulk-action-modal__label">New Status</label>
      <Dropdown
        items={statusDropdownItems}
        value={selectedStatus}
        onChange={handleStatusChange}
        placeholder="Select status..."
      />
    </BulkActionModal>
  );
};

export default BulkStatusChangeModal;
